module.exports = __webpack_public_path__ + "static/media/logo@2x.9062759d.png";